import { takeLatest, takeEvery } from 'redux-saga/effects';

import { getAccountPath } from '../../utils/firebase';
import { post, put } from '../../utils/request';
import {
  fetchJobsRoutine,
  fetchJobRoutine,
  saveJobRoutine,
  saveJobResourcesRoutine,
  removeJobRoutine,
} from '../routines';
import { fetchSaga, removeSaga, saveSaga } from './helper';

function* watchFetchJobsSaga() {
  yield takeLatest(fetchJobsRoutine.TRIGGER, fetchSaga(fetchJobsRoutine, (params) => {
    // console.log('watchFetchJobsSaga-params', params);
    let url = getAccountPath('jobs') + '?';
    if (params && params.date) {
      url += `date=${params.date.toISOString()}`;
    }
    return url;
  }));
}

function* watchFetchJobSaga() {
  yield takeLatest(fetchJobRoutine.TRIGGER, fetchSaga(fetchJobRoutine, (payload) => getAccountPath('jobs', payload.id)));
}

function* watchSaveJobSaga() {
  yield takeEvery(saveJobRoutine.TRIGGER, saveSaga(
    saveJobRoutine,
    (payload) => getAccountPath('jobs', payload.values.get('id')),
    (payload) => payload.values.get('id') ? put : post,
    (payload) => payload.values));
}

// TODO this is unlikely to work - IMPORTANT
function* watchSaveJobResourcesSaga() {
  // run fetchDataFromServer on every trigger action
  yield takeEvery(saveJobResourcesRoutine.TRIGGER,
    saveSaga(saveJobResourcesRoutine,
      (job) => `${getAccountPath('jobs', job.id)}/resources`,
      () => put,
      (job) => job.resources));
}

function* watchRemoveJobSaga() {
  yield takeEvery(removeJobRoutine.TRIGGER, removeSaga(removeJobRoutine, (payload) => getAccountPath('jobs', payload.id)));
}

export {
  watchFetchJobsSaga,
  watchFetchJobSaga,
  watchSaveJobSaga,
  watchSaveJobResourcesSaga,
  watchRemoveJobSaga,
};



// WEBPACK FOOTER //
// ./src/redux/sagas/jobs.js